module.exports = __webpack_public_path__ + "static/media/coins-message-background.4f079454.png";